import React from "react";
import DashboardConfigurator from "./dashboardConfigurator";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";

import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
export let configuratorStore;

export function createDashboardConfiguratorStore() {
  configuratorStore = createReduxStore("dashboardConfigurator");
  return configuratorStore;
}

class Dashboard extends React.Component {
  render() {
    return (
      <Provider store={createDashboardConfiguratorStore()}>
        <ErrorBoundary {...this.props.notifications} moduleName="dashboardConfigurator">
          <DashboardConfigurator currentUser={this.props.params} />
        </ErrorBoundary>
      </Provider>
    );
  }
}
export default Dashboard;
